import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Tag, Space, Spin } from "antd";
import { SettingOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { formatAmount } from "../../config/helpers.js";
import useCompanies from "../../hooks/useCompanies.js";
import { db } from "../../config/firebase.js";
import { collection, doc, getDocs, updateDoc, writeBatch } from "firebase/firestore";

// Default array to populate the store missing fields
const DEFAULT_COMPANY_RATES = [
  { key: "normal", label: "Non majoré", amount: 0 },
  { key: "major", label: "Majoré", amount: 0 },
];

const DEFAULT_AGENT_RATES = [
  { key: "day", label: "Jour", amount: 0 },
  { key: "night", label: "Nuit", amount: 0 },
];

export default function PricingRulesModal({ open, onClose }) {
  /**
   * Logic to populate new field
   * TODO: delete after updating fields on the production collections

  const [collectionFieldsUpdated, setCollectionFieldsUpdated] = useState(0);
  async function populateClientRates() {
    const snap = await getDocs(collection(db, "clients"));

    let updated = 0;
    const batch = writeBatch(db);

    snap.forEach((docSnap) => {
      const data = docSnap.data();
      const updates = {};

      // ✅ Populate ONLY if field does NOT exist
      if (!("companyRates" in data)) {
        updates.companyRates = DEFAULT_COMPANY_RATES;
      }

      if (!("agentRates" in data)) {
        updates.agentRates = DEFAULT_AGENT_RATES;
      }

      if (Object.keys(updates).length > 0) {
        batch.update(docSnap.ref, updates);
        updated++;
      }
    });

    if (updated > 0) {
      await batch.commit();
    }
    setCollectionFieldsUpdated(1); // ton state UI

    console.log(`✅ Updated ${updated} clients`);
  }
  useEffect(() => {
    populateClientRates();
  }, [populateClientRates])*/

  const [loading, isLoading] = useState(false);

  const {
    companies,
    loading: lodingCompanies,
    getCompanies,
    setCompanies
  } = useCompanies();


  useEffect(() => {
    getCompanies()
  }, [getCompanies])

  const [search, setSearch] = useState("");
  const [editingCompany, setEditingCompany] = useState(null);

  const filteredCompanies = companies.filter((c) =>
    c.enterprise.toLowerCase().includes(search.toLowerCase())
  );

  const handleRateChange = (type, index, field, value) => {
    setEditingCompany((prev) => {
      const updated = { ...prev };
      updated[type][index][field] = field === "amount" ? Number(value) : value;
      return updated;
    });
  };

  const handleAddRate = (type) => {
    setEditingCompany((prev) => {
      const updated = { ...prev };
      updated[type] = [...updated[type], { key: Date.now().toString(), label: "", amount: 0 }];
      return updated;
    });
  };

  const handleRemoveRate = (type, index) => {
    setEditingCompany((prev) => {
      const updated = { ...prev };
      updated[type] = updated[type].filter((_, i) => i !== index);
      return updated;
    });
  };

  const handleSave = async () => {
    isLoading(true);
    const companyRef = doc(db, "clients", editingCompany.uid || editingCompany.id);
    await updateDoc(companyRef, {
      companyRates: editingCompany.companyRates,
      agentRates: editingCompany.agentRates,
    });
    setCompanies((prev) =>
      prev.map((c) => (c.uid === editingCompany.uid ? editingCompany : c))
    );
    setEditingCompany(null);
    isLoading(false);
  };

  // TODO: Delete this after update the fields on collections in production
  //if (collectionFieldsUpdated < 1) return;

  return (
    <Modal
      open={open}
      onCancel={() => {
        setEditingCompany(null);
        onClose();
      }}
      footer={null}
      width={900}
      title="Tarifs par entreprise"
    >
      {!editingCompany ? (
        <>
          <Input
            placeholder="Rechercher une entreprise..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ marginBottom: 16, height: 40, borderRadius: 8 }}
          />

          <div className="pricing-list">
            {filteredCompanies.map((company, index) => (
              <div key={`${company.id}-${index}`} className="pricing-card">
                <div className="pricing-card-header">
                  <div>
                    <h4>{company.enterprise}</h4>
                    <Tag color="blue">{company.companyRates ? company.companyRates.length : 0} tarifs entreprise</Tag>
                    <Tag color="green">{company.agentRates ? company.agentRates.length : 0} tarifs agent</Tag>
                  </div>
                  <Button
                    icon={<SettingOutlined />}
                    type="text"
                    className="edit-btn"
                    onClick={() => setEditingCompany(company)}
                  >
                    Modifier
                  </Button>
                </div>

                <div className="pricing-card-body">
                  <div className="pricing-section">
                    <span className="section-title">Entreprise</span>
                    {company.companyRates.map((rate, index) => (
                      <div key={`${company.id}-${rate.key}-${index}`} className="rate-row">
                        <span>{rate.label}</span>
                        <strong>{formatAmount(rate.amount)}</strong>
                      </div>
                    ))}
                  </div>

                  <div className="pricing-section">
                    <span className="section-title">Agents</span>
                    {company.agentRates.map((rate, index) => (
                      <div key={`${company.id}-${rate.key}-${index}`} className="rate-row">
                        <span>{rate.label}</span>
                        <strong>{formatAmount(rate.amount)}</strong>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          {loading ? (
            <div style={{textAlign: "center"}}>
              <Spin size="large" />
            </div>
          ) : (
            <>
              <h3 style={{ marginBottom: 16 }}>{editingCompany.name}</h3>

              <div className="pricing-list">
                {["companyRates", "agentRates"].map((type) => (
                  <div key={type} className="pricing-section">
                    <span className="section-title">
                      {type === "companyRates" ? "Entreprise" : "Agents"}
                    </span>

                    {editingCompany[type].map((rate, index) => (
                      <Space key={rate.key} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                        <Input
                          placeholder="Label"
                          value={rate.label}
                          onChange={(e) => handleRateChange(type, index, "label", e.target.value)}
                        />
                        <Input
                          placeholder="Montant"
                          type="number"
                          value={rate.amount}
                          onChange={(e) => handleRateChange(type, index, "amount", e.target.value)}
                          style={{ width: 100 }}
                        />
                        <Button
                          icon={<DeleteOutlined />}
                          onClick={() => handleRemoveRate(type, index)}
                        />
                      </Space>
                    ))}

                    <Button
                      type="dashed"
                      icon={<PlusOutlined />}
                      onClick={() => handleAddRate(type)}
                      style={{ marginTop: 8 }}
                    >
                      Ajouter un tarif
                    </Button>
                  </div>
                ))}

                <div style={{ marginTop: 16, textAlign: "right" }}>
                  <Button onClick={() => setEditingCompany(null)} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button type="primary" onClick={handleSave}>
                    Enregistrer
                  </Button>
                </div>
              </div>
            </>
          )}
        </>
      )}

      {/* Styles */}
      <style>{`
        .pricing-list {
          max-height: 520px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          gap: 12px;
          padding-right: 6px;
        }

        .pricing-card {
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          background: #fff;
          padding: 16px;
          transition: box-shadow 0.2s ease;
        }

        .pricing-card:hover {
          box-shadow: 0 8px 24px rgba(0,0,0,0.08);
        }

        .pricing-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .pricing-card-header h4 {
          margin: 0;
        }

        .pricing-card-body {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .pricing-section {
          background: #f9fafb;
          border-radius: 8px;
          padding: 12px;
        }

        .section-title {
          font-size: 12px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          display: block;
          margin-bottom: 8px;
        }

        .rate-row {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          padding: 4px 0;
        }

        .edit-btn {
          color: #2563eb;
          font-weight: 500;
        }

        .pricing-list::-webkit-scrollbar {
          width: 6px;
        }
        .pricing-list::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
      `}</style>
    </Modal>
  );
}
